import { render, staticRenderFns } from "./fotoperfil.vue?vue&type=template&id=af0908ee&"
import script from "./fotoperfil.vue?vue&type=script&lang=js&"
export * from "./fotoperfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports